<div class="h-screen flex flex-col">
  <header-with-menu [showLogo]="showHeaderLogo" [icon]="gundryLogo" [showContent]="showHeaderContent" [headerText]="headerText" [showOnOrderForm]="showOnOrderForm"></header-with-menu>
    <div class="flex-1 bg-white flex justify-center p-4">
      <div class="text-center max-w-2xl pt-32">
        <p class="">Oops! We had a technical error. Our team is working to fix it right now.</p>
        <p class="">In the meantime, please call 800-955-1518 to ensure your order processed correctly.</p>
        <p class="">We apologize for any inconvenience. Thank you for joining the Hartfelt family!</p>
      </div>
    </div>
  <upsell-footer class="flex-shrink-0"></upsell-footer>
</div>
 